import { type FetchSocialFeedMeByFeedSlugParams, useLocale } from '@capsicum/common';
import { userFeedKeys } from '@capsicum/socios-core';

import { useSocialFeedMeQuery } from '../data-access';
import { clearFeedPages, prepareFeedData } from '../util';

export const useMeUserFeed = () => {
	const { locale } = useLocale();
	const key = userFeedKeys.me();
	const params: FetchSocialFeedMeByFeedSlugParams = {
		feedSlug: 'fan_profile',
		limit: 10,
		locale: locale
	};

	const {
		data,
		error,
		fetchNextPage,
		hasNextPage,
		isFetched,
		isFetching,
		isLoading,
		refetch: refetchQuery
	} = useSocialFeedMeQuery(key, params);

	const { feedData, metadata } = prepareFeedData(data);

	const refetch = async () => {
		clearFeedPages(key);
		await refetchQuery();
	};

	enum MyProfileTabs {
		Activity = 'activity'
	}

	return {
		data: feedData,
		error,
		fetchNextPage,
		hasNextPage,
		isFetched,
		isFetching,
		isLoading,
		metadata,
		MyProfileTabs,
		refetch
	};
};
